import Vue from 'vue'
import Vuex from 'vuex'
import { getInstance } from '@/auth/auth0-plugin'

// API
import Party from '@/api/party'
import Items from '@/api/endpoints'
// Modules
import sources from './modules/source'
import key_value from './modules/key_value'

Vue.use(Vuex)

const namespaced = true
const modules = { sources, key_value }

const strict = false

const state = {
  userRelatedParties: [],
  departmentCategoryMapping: [],
  categorySubcategoryMapping: [],
  partySourceRelationships: [],
  stores: []
}

const mutations = {
  setUserRelatedParties (state, payload) {
    state.userRelatedParties = payload
  },
  setPartySourceRelationships(state, payload) {
    state.partySourceRelationships = payload
  },
  setDepartmentCategoryMapping(state, payload) {
    state.departmentCategoryMapping = payload
  },
  setCategorySubcategoryMapping(state, payload) {
    state.categorySubcategoryMapping = payload
  },
  setStores(state, payload) {
    state.stores = payload
  }
}

const actions = {
  async getDepartmentCategoryMapping (context, params) {
    let departmentCategoryMapping = []
    try {
      const data = await Items.getPossibleValues('department', 'category', params.sources, params.is_retailer)
      if (data) {
        departmentCategoryMapping = data
      }
      return context.commit('setDepartmentCategoryMapping', departmentCategoryMapping)
    } catch (err) {
      console.error(err)
    }
  },
  async getCategorySubcategoryMapping (context, params) {
    let categorySubcategoryMapping = []
    try {
      const data = await Items.getPossibleValues('category', 'subcategory', params.sources, params.is_retailer)
      if (data) {
        categorySubcategoryMapping = data
      }
      return context.commit('setCategorySubcategoryMapping', categorySubcategoryMapping)
    } catch (err) {
      console.error(err)
    }
  },
  async getUserRelatedParties (context) {
    const userParties = context.getters.userRelatedParties
    if (userParties.length > 0) return

    const authService = getInstance()
    const { email } = authService.user
    let include_stores = false
    if (authService.tenant === 'jbg' && !authService.isAdmin) {
      include_stores = authService.userRoles.includes('jbg-retailer')
    }
    let relatedParties = []
    const res = await Party.getUserProfile(email, include_stores)
    if (res && res.data && res.data.length > 0) {
      relatedParties = res.data
    }
    return context.commit('setUserRelatedParties', relatedParties)
  },

  async getStores(context) {
    if (context.getters.stores.length > 0) return
    let stores = []
    try {
      const res = await Party.getStores()
      if (res && res.data && res.data.length > 0) {
        stores = res.data.map(store => {
          const { attributes } = store
          const storeNumber = attributes && attributes.WHOLESALER_STORE_NUMBER 
            ? attributes.WHOLESALER_STORE_NUMBER
            : ''
          return {
            attributes: store.attributes,
            id: store.id,
            name: `#${storeNumber} ${store.name}`,
            party_id: store.id,
            tenant: store.tenant
          }
        }).toSorted((a, b) => a.name - b.name)
      }
      return context.commit('setStores', stores)
    } catch (err) {
      console.error(err)
    }
  },

  async getPartySourceRelationships (context) {
    const partySourceRelationships = context.getters.partySourceRelationships
    if (partySourceRelationships.length > 0) return

    let relationships = []
    const res = await Items.getPartySourceRelationships()
    if (res && res.length > 0) {
      relationships = res
    }
    return context.commit('setPartySourceRelationships', relationships)
  }
}

const getters = {
  userRelatedParties (state) {
    return state.userRelatedParties
  },
  partySourceRelationships (state) {
    return state.partySourceRelationships
  },
  departmentCategoryMapping (state) {
    return state.departmentCategoryMapping
  },
  categorySubcategoryMapping (state) {
    return state.categorySubcategoryMapping
  },
  stores (state) {
    return state.stores
  }
}

export const store = new Vuex.Store({
  state,
  strict,
  actions,
  modules,
  getters,
  mutations,
  namespaced
})



// WEBPACK FOOTER //
// ./src/store/index.js